
import React from 'react';
import { StepProps } from '../props/StepProps';
import { Button, Col, Row } from 'antd';


interface ButtonProps extends StepProps {
    disable?: boolean;
    isChange?: boolean;
}

export const ButtonList = ({
    current,
    maxStep = 2,
    next,
    prev,
    disable
}: ButtonProps) => {

    return (
        <>
            <Row justify="center" className='w-full mb-6'>
                {current > 0 && (
                    <Col span={12} style={{paddingRight: '8px'}}>
                        <Button
                            size='large'
                            className='button-container previous'
                            onClick={() => prev && prev()}
                        >
                            戻る
                        </Button>
                    </Col>
                )}
                <Col span={12} style={{paddingLeft: '8px'}}>
                    <Button type="primary" size='large' disabled={disable}
                        onClick={() => next && next()}
                        className='button-container'>
                        {current === maxStep ? '確認する' : '次へ'}
                    </Button>
                </Col>
            </Row>
        </>
    );

}